import React, { useState } from 'react';
import styled from 'styled-components';

import TokenForm, { DrawerForm } from 'components/token/TokenForm';
import DeployToken from 'components/token/Deploy';

import { useRecoilState, useRecoilValue } from 'recoil';
import { tokenState, metamaskState, feesState } from 'global/state';
import { Button } from 'antd';
import { Network, ETH_FEES_AMOUNT, BNB_FEES_AMOUNT } from 'components/utils';


const TokenUI = (props) => {
  const token = useRecoilValue(tokenState);
  const metamask = useRecoilValue(metamaskState);

  const [ showDrawer, setShowDrawer ] = useState(false);
  const [ deployToken, setDeployToken ] = useState(false);
  const [ fees, setFees ] = useRecoilState(feesState);

  const handleClose = () => {
    setShowDrawer(false);
  }

  const beginTokenDeployment = () => {
    if ( metamask?.network === Network.BSC ) {
      setFees({
        amount: BNB_FEES_AMOUNT,
        currency: 'BNB'
      });
    } else {
      setFees({
        amount: ETH_FEES_AMOUNT,
        currency: 'ETH'
      });
    }
    setDeployToken(true);
  }

  return (
    <div>

      { token && ! token.completed &&
        <TokenForm />
      }

      { token && token.completed && ! deployToken &&
        <DetailsContainer>
          <p>Please verify the details you've entered, You cannot change it after deployment.</p>

          <div className="token-details">
            <p>Token Name: <strong>{ token.name }</strong></p>
            <p>Token Symbol: <strong>{ token.symbol }</strong></p>
            <p>Token Decimal: <strong>{ token.decimal }</strong></p>
            <p>Token Supply: <strong>{ token.supply } Tokens</strong></p>
            <Button type="primary" ghost block onClick={ () => { setShowDrawer(true) } }>Modify Token</Button>
            <BigButton type="primary" block onClick={ beginTokenDeployment }>Everything Is Correct. <br />Begin Token Deployment</BigButton>
          </div>

          { showDrawer && <DrawerForm handleClose={ handleClose } /> }

        </DetailsContainer>
      }

      { deployToken && <DeployToken /> }

    </div>
  )


}

export default TokenUI;




const DetailsContainer = styled.div`
  margin-top: 20px;
  border: 1px solid #434b5a;
  padding: 30px;
  border-radius: 5px;

  p {
    font-size: 16px;
    line-height: 20px;
    font-family: 'Balsamiq Sans', cursive;
    color: #2196f3;
  }

  .token-details p {
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
  }
  .token-details button { margin-top: 10px; }

  strong { text-decoration: underline; color: #FFF; }

`;

const BigButton = styled(Button)`
  margin-top: 30px !important;
  height: 60px;
  font-size: 16px;
  line-height: 20px;
  font-family: 'Balsamiq Sans', cursive;
  background-color: #348838;
  border: 4px solid #19801e;

  &:hover, &:focus, &:active {
    background-color: #236526;
    border: 4px solid #236526;
  }


`;


